export const TRANSACTION_STATUSES = {
  STRUCTURING: "STRUCTURING",
  LEGAL_REVIEW: "LEGAL_REVIEW",
  WAITING_SIGNATURE: "WAITING_SIGNATURE",
  FUNDRAISING: "FUNDRAISING",
  READY_TO_FUND: "READY_TO_FUND",
  FUNDED: "FUNDED",
  ACTIVE: "ACTIVE",
  EXIT_PREPARATION: "EXIT_PREPARATION",
  REFINANCING: "REFINANCING",
  COMPLETED: "COMPLETED",
  CANCELLED: "CANCELLED",
  DEFAULTED: "DEFAULTED",
  PENDING: "PENDING",
};

export const TRANSACTION_STATUSES_LABELS = {
  [TRANSACTION_STATUSES.STRUCTURING]: "En structuration",
  [TRANSACTION_STATUSES.LEGAL_REVIEW]: "Revue juridique",
  [TRANSACTION_STATUSES.WAITING_SIGNATURE]: "En attente de signature",
  [TRANSACTION_STATUSES.FUNDRAISING]: "En levée de fonds",
  [TRANSACTION_STATUSES.READY_TO_FUND]: "Prêt à financer",
  [TRANSACTION_STATUSES.FUNDED]: "Financé",
  [TRANSACTION_STATUSES.ACTIVE]: "Actif",
  [TRANSACTION_STATUSES.EXIT_PREPARATION]: "Préparation de sortie",
  [TRANSACTION_STATUSES.REFINANCING]: "Refinancement",
  [TRANSACTION_STATUSES.COMPLETED]: "Clôturé",
  [TRANSACTION_STATUSES.CANCELLED]: "Annulé",
  [TRANSACTION_STATUSES.DEFAULTED]: "En incident",
  [TRANSACTION_STATUSES.PENDING]: "En cours de structuration",
};
